/**
 * Shared pre-submit validation for the two emulation start dialogs
 * (super-admin `EmulateUserModal`, enterprise `EnterpriseEmulateModal`).
 * Pure + dependency-free so both dialogs and the unit test consume the
 * identical rules. UI concerns (focus, rendering) live in the dialogs.
 */
export const REASON_MIN = 10;

export interface EmulationFormErrors {
  reason?: string;
  password?: string;
  suppressionReason?: string;
}

export interface EmulationFormInput {
  reason: string;
  password: string;
  /** Super-admin only. When omitted/false, suppressionReason is ignored. */
  suppress?: boolean;
  suppressionReason?: string;
}

export function validateEmulationForm(
  input: EmulationFormInput,
): EmulationFormErrors {
  const errors: EmulationFormErrors = {};

  if (input.reason.trim().length < REASON_MIN) {
    errors.reason = `Reason needs at least ${REASON_MIN} characters`;
  }

  if (input.password.length === 0) {
    errors.password = 'Enter your password to confirm';
  }

  if (input.suppress && (input.suppressionReason ?? '').trim().length < REASON_MIN) {
    errors.suppressionReason = `Suppression reason needs at least ${REASON_MIN} characters`;
  }

  return errors;
}
